
<template>
  <v-dialog v-model="dialog" v-if="dialog" max-width="800px" transition="dialog-transition" >
    <v-card style="border-radius:12px">
      <v-card-title primary-title>
        <div class="title mb-0">Comissão por produto</div>
        <v-spacer></v-spacer>
        <v-btn v-if="one_comission.id" text icon small color="error" @click="submitDelete"><v-icon>delete</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <div>
          <v-row>
            <v-col cols='5'>
              <v-autocomplete
                v-model="one_comission.brand_id"
                :items="brands"
                :loading="loading_brands"
                label="Marca"
                prepend-icon="add_shopping_cart"
                hide-no-data
                item-text="name"
                item-value="id"
                item-disabled="off"
                :rules="[rules.notSoRequired]"
              >
                <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
              </v-autocomplete>
            </v-col>
            <v-col cols='5' v-if="is_employee">
              <v-autocomplete
                :disabled="!one_comission.brand_id"
                v-model="one_comission.product_id"
                :items="products"
                :loading="loading_products"
                label="Produto"
                prepend-icon="add_shopping_cart"
                hide-no-data
                item-text="name"
                item-value="id"
                item-disabled="off"
                :rules="[rules.notSoRequired]"
              >
                <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
              </v-autocomplete>
            </v-col>
            <v-col cols='5' v-if="is_product">
              <v-autocomplete
                v-model="one_comission.employee_id"
                :items="employees"
                :loading="loading_employees"
                label="Colaborador"
                prepend-icon="add_shopping_cart"
                hide-no-data
                item-text="name"
                item-value="id"
                item-disabled="off"
                :rules="[rules.notSoRequired]"
                @change="one_comission.comission_type = null"
              >
                <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-autocomplete
            v-model="one_comission.comission_type"
            :items="available_comissions"
            label="Modelo de comissão"
            prepend-icon="add_shopping_cart"
            hide-no-data
            item-text="name"
            item-value="value"
            item-disabled="off"
            @change="genJobDetails()"
            :rules="[rules.notSoRequired]"
          >
            <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
          </v-autocomplete>

          <v-text-field v-money="money" :rules="[rules.required]" v-model="one_comission.comission_floor" 
            v-if="one_comission.comission_type == 1" label="Informe o valor (R$)" prepend-icon="mdi-account-cash">
          </v-text-field>
          <v-text-field v-money="money" :rules="[rules.notZeroPercentage]" v-model="one_comission.comission_floor" 
            v-if="one_comission.comission_type == 2" label="Informe a porcentagem (%)" 
            prepend-icon="mdi-percent" hint="% do lucro">
          </v-text-field>
          <v-text-field v-money="money" :rules="[rules.required]" v-model="one_comission.comission_floor" 
            v-if="one_comission.comission_type == 4" label="Informe o valor (R$)" prepend-icon="mdi-account-cash">
          </v-text-field>

          <v-text-field v-money="money" :rules="[rules.required, rules.notZero]" v-model="one_comission.comission_floor" 
            v-if="one_comission.comission_type == 3" label="Comissão inicial (R$)" prepend-icon="mdi-account-cash">
          </v-text-field>
          <v-text-field v-money="money" :rules="[rules.required, rules.notZero]" v-model="one_comission.profit_floor" 
            v-if="one_comission.comission_type == 3" label="Lucro inicial (R$)" prepend-icon="mdi-account-cash">
          </v-text-field>
          <v-text-field v-money="money3" :rules="[rules.required, rules.notZero3]" v-model="one_comission.profit_step" 
            v-if="one_comission.comission_type == 3" label="Lucro incremental (R$)" prepend-icon="mdi-account-cash">
          </v-text-field>
          <v-text-field v-money="money3" :rules="[rules.required, rules.notZero3]" v-model="one_comission.comission_step" 
            v-if="one_comission.comission_type == 3" label="Comissão incremental (R$)" prepend-icon="mdi-account-cash">
          </v-text-field>
          
        </div>
      </v-card-text>
      <v-card-actions class="justify-end">
        <f-btn cancel small @click="dialog = false"></f-btn>
        <f-btn save small @click="submitComission()"></f-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-if="loading" v-model="loading" persistent max-width="800px" transition="dialog-transition" >
      <v-alert type="info" :value="true">
        <div>
        Atualizando...
        </div>
        <div>
          <v-progress-linear color="white" :indeterminate="true"></v-progress-linear>
        </div>
      </v-alert>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import {VMoney} from 'v-money'
import Api from '@/api/index';

export default {
  name: 'OneComission',
  directives: {money: VMoney},
  props: {
    main_data: {
      type: Object,
    },
    comission: {
      type: Object,
    },
    is_employee: {
      type: Boolean,
      default: true
    },
    is_product: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dialog: true,
      loading: false,
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: true
      },
      money3:{
        decimal: '.',
        thousands: ',',
        precision: 3,
        masked: true
      },
      rules: {
        required: v => !!v || 'Campo é necessário',
        notZeroPercentage: v => (!!v && v != '0.00' && parseFloat(v) < 100) || 'Formato válido: "99.99"',
        notZero: v=> v != '0.00' || 'Não pode ser zero',
        notZero3: v=> v != '0.000' || 'Não pode ser zero',
        notSoRequired: v => ([1,5,6].includes(this.one_comission.job) || !!v || 'Campo necessário'), 
        email: v => /.+@.+/.test(v) || 'E-mail deve ser válido',
        cpf: v => (v && v.length == 11) || 'CPF deve ser completo',
      },
      loading_brands: false,
      brands: [],
      loading_products: false,
      products: [],
      loading_employees: false,
      employees: [],
      one_comission: {
        employee_id: null,
        brand_id: null,
        product_id: null,
        comision: '',
        comission_type: '',
        comission_floor: '',
        profit_floor: '',
        comission_step: '',
        profit_step: '',
      },
      comissions: [ {name: 'Modelo 1 - R$ por unidade', value: 1, off: false},
                      //comType = 1, comFloor = vR$ * qtd, prFloor = 0, pfStep = 0, comStep = 0
                      {name: 'Modelo 2 - % do lucro', value: 2, off: false},
                      //comType = 2, comFloor = v% * lucro , prFloor = 0, pfStep = 0, comStep = 0
                      {name: 'Modelo 3 - Faixas', value: 3, off: false},
                      //comType = 3, comFloor = vR$, prFloor = start valAcimaLucro, pfStep = 0,25, comStep = $0,01                      
                      // {name: 'Modelo 4 - Gerente', value: 4, off: false},
                      //comType = 4, comFloor = vR$ * qtd, prFloor = 0, pfStep = 0, comStep = 0                      
                      // {name: 'Modelo 5 - Motorista', value: 5, off: false}
                  ],
                      //comType = 5, comFloor = v% * frete, prFloor = 0, pfStep = 0, comStep = 0  
    }
  },
  methods: {
    setupOneComission(){
      this.one_comission = {...this.comission}
    },
    genJobDetails(){
      var ct = this.one_comission.comission_type
      
      if (ct == 1 || ct == 2 || ct == 4 ){
        this.one_comission.profit_floor = 0
        this.one_comission.profit_step = 0
        this.one_comission.comission_step = 0
      } else if (ct == 3) {
      }
    },
    submitDelete(){
      this.swallConfirmation({
        title: `Certeza em excluir comissão? Essa ação é irreversível`,
        icon: 'question',
      }).then( confirmed =>{
        if (confirmed ) {
          if (this.one_comission.id){
            this.loading = true
            Api.Comission.delete(this.one_comission).then(r=>{
              this.addNotification({type: 'success',  msg: `Excluído com sucesso!.`})
              this.$emit('updated',)
            }).catch(err=>{
              console.error(err);
              this.addNotification({type: 'error',  msg: `${err}`})
            }).finally(()=>{
              this.loading = false
            })
          }
        }
      })
    },
    submitComission(){
      this.swallConfirmation({
        title:  `Certeza em ${this.one_comission.id? 'atualizar' : 'criar'} comissão?`,
        icon: 'question',
      }).then( confirmed =>{
        if (confirmed ) {
          if (this.one_comission.id){
            this.loading = true
            Api.Comission.update(this.one_comission).then(r=>{
              this.$emit('updated',)
              this.addNotification({type: 'success',  msg: `Atualizado com sucesso!.`})
            }).catch(err=>{
              console.error(err);
              this.addNotification({type: 'error',  msg: `${err}`})
            }).finally(()=>{
              this.loading = false
            })

          } else {
            let brand_name = this.brands.find(o=>o.id == this.one_comission.brand_id).name;
            let product_name = this.one_comission.product_id ? this.products.find(o=>o.id == this.one_comission.product_id).name : '';
            let employee_name = this.one_comission.employee_id ? this.employees.find(o=>o.id == this.one_comission.employee_id).name : '';
            let comission_name = this.comissions.find(o=>o.value == this.one_comission.comission_type).name
            let idx = 0
            if (this.one_comission.index != null || this.one_comission.index != undefined){
              idx = this.one_comission.index
              this.main_data.comissions_attributes[idx] = {...this.one_comission, comission_name, brand_name, product_name, employee_name}
              this.$emit('new-changed', {idx, comission: {...this.one_comission, comission_name, brand_name, product_name, employee_name}})
            }else{
              this.$emit('done', {...this.one_comission, comission_name, brand_name, product_name, employee_name})
              // this.main_data.comissions_attributes.push({...this.one_comission, comission_name, brand_name, product_name})
            }
            this.dialog = false
          }
        }
      })

      
    },
    getBrands(){
      this.loading_brands = true
      Api.Supplier.index('brands', {only_brands: true}).then(r=>r.data).then(d=>{
        d = d.data? d.data.map(da=> da.attributes) : d
        this.brands = [...d]
        if (this.main_data.brand_ids && this.main_data.brand_ids.length){
          this.brands = this.brands.filter(b=> this.main_data.brand_ids.includes(Number(b.id)))
        }
      }).finally(()=>{
        this.loading_brands = false
      })
    },
    getProducts(id){
      this.loading_products = true
      Api.Supplier.indexByModel('brands',id,'products').then(r=>r.data).then(d=>{
        d = d.data? d.data.map(da=> da.attributes) : d
        this.products = [...d]
      }).finally(()=>{
        this.loading_products = false
      })
    },
    getEmployees(){
      this.loading_employees = true
      Api.Employee.index({roles: ['Seller', 'Manager']}).then(r=>r.data).then(d=>{
        d = d.data? d.data.map(da=> da.attributes) : d
        this.employees = [...d]
      }).finally(()=>{
        this.loading_employees = false
      })
    },
  },
  created () {
    if (this.comission && this.comission.comission_type){
      this.setupOneComission()
    }
    this.getBrands()
  },
  mounted () {
    this.getEmployees();
  },
  computed: {
    available_comissions() {
      if (this.is_employee){
        let role = this.main_data.id? ( this.main_data.role.data? this.main_data.role.data[0].attributes.name : this.main_data.role ) : this.main_data.jobDetails.job_name
        if (role == "Seller"){
          return this.comissions
        } else if (role == "Manager"){
          return [{name: 'Modelo 4 - Gerente', value: 1, off: false}]
        }
      } else if (this.is_product && this.employees.length && this.one_comission.employee_id) {
        let role = this.employees.find(em=> Number(em.id) == Number(this.one_comission.employee_id) ).role.data[0].attributes.name
        if (role == "Seller"){
          return this.comissions
        } else if (role == "Manager"){
          return [{name: 'Modelo 4 - Gerente', value: 1, off: false}]
        }
      }
      return this.comissions
    },
  },
  watch: {
    dialog(nv,ov) {
      if (nv == false){
        this.$emit('close')
      }
    },
    'one_comission.brand_id'(nv,ov) {
      if (nv && this.is_employee){
        this.getProducts(nv)
      }
    }
  },
}
</script>